<template>
	<div v-if="detail.triglycerides||detail.lowDensityFat">
		<base-card title="血脂水平分析（mmol/L）" class="mt-28">
			<numberCard :list="numberList" />
			<textCard
				class="mt-40"
				:list="[
                            '根据医学指南：',
                            '甘油三酯目标值为：＜1.7mmol/L',
                            '缺血性卒中及卒中极高危人群：',
                            '低密度脂蛋白胆固醇目标值为＜1.8mmol/L',
                            '卒中高危人群：',
                            '低密度脂蛋白胆固醇目标值为＜2.6mmol/L',
                            '卒中中低危人群：',
                            '低密度脂蛋白胆固醇目标值为＜3.4 mmol/L',
                            '如有疑问，请咨询医生。',
                ]"
			/>
		</base-card>
		<remind title="温馨提示" :list="tips" />
	</div>
	<van-empty
		v-else
		description="您本月未记录血脂，无法为您做出分析和建议，建议您在做完血脂检测后，及时上传相关数据，我们将在下月1日为您进行分析、出具血脂数据报告"
	/>
</template>
<script>
import numberCard from './report-number-card.vue'
import textCard from './report-deatil-text.vue'
import remind from './report-detail-remind.vue'
export default {
    name: 'reportFat',
    components: { numberCard, textCard, remind, },
    props: {
        detail: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        baseData () {
            return this.detail.bloodPressureRecordList || []
        },
        patient () {
            return this.detail.patientDetail || {}
        },
        tag () {
            return this.patient.patientTag || []
        },
        status () {
            let ret = 'common'
            let num = this.patient.multiplierValue
            if (num <= 3.5 && num >= 0) {
                ret = 'low'
            } else if (num <= 7 && num >= 3.6) {
                ret = 'between'
            } else if (num <= 10 && num >= 7.1) {
                ret = 'top'
            } else if (num > 10) {
                ret = 'high'
            }
            return ret
        },
        numberList () {
            const { triglycerides, lowDensityFat } = this.detail
            let triglyceridesColor = '#14C9C9'
            let lowDensityFatColor = '#14C9C9'
            let base = 3.4
            if (triglycerides >= 1.7) {
                triglyceridesColor = '#FA5151'
            }
            if (this.tag.indexOf('缺血性卒中') > -1 || this.status === 'high') {
                base = 1.8
            } else if (this.status === 'top') {
                base = 2.6
            }
            if (lowDensityFat >= base) {
                lowDensityFatColor = '#FA5151'
            }
            return [
                { label: '甘油三酯', value: triglycerides, color: triglyceridesColor },
                { label: '低密度脂蛋白胆固醇', value: lowDensityFat, color: lowDensityFatColor }
            ]
        },
        type () {
            return this.patient.questionnaireType
        },
        tips () {
            const { triglycerides, lowDensityFat } = this.detail
            let ret = [
                '',
                '血脂水平的个体化差异较大，请您遵医嘱合理控制血脂！',
            ]
            if (triglycerides < 1.7) {
                if (lowDensityFat < 1.8) {
                    ret[0] = '您本月的甘油三酯和低密度脂蛋白胆固醇均控制在目标值范围内。建议您继续按医嘱规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                }
                if (lowDensityFat > 3.4) {
                    ret[0] = '您本月的甘油三酯控制在目标值范围内，但低密度脂蛋白胆固醇未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                }
                if (lowDensityFat >= 2.6 && lowDensityFat < 3.4) {
                    if (['low', 'between', 'common'].indexOf(this.status) > -1 && this.type === 2) {
                        ret[0] = '您本月的甘油三酯和低密度脂蛋白胆固醇均控制在目标值范围内。建议您继续按医嘱规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                    if (['top', 'high'].indexOf(this.status) > -1 || this.type === 1) {
                        ret[0] = '您本月的甘油三酯控制在目标值范围内，但低密度脂蛋白胆固醇未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                }
                if (lowDensityFat >= 1.8 && lowDensityFat < 2.6) {
                    if (['high'].indexOf(this.status) > -1 || this.type === 1) {
                        ret[0] = '您本月的甘油三酯控制在目标值范围内，但低密度脂蛋白胆固醇未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                    if (['top', 'low', 'between', 'common'].indexOf(this.status) > -1 && this.type === 2) {
                        ret[0] = '您本月的甘油三酯和低密度脂蛋白胆固醇均控制在目标值范围内。建议您继续按医嘱规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                }
            }
            if (triglycerides >= 1.7) {
                if (lowDensityFat < 1.8) {
                    ret[0] = '您本月的低密度脂蛋白胆固醇控制在目标值范围内，但甘油三酯未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                }
                if (lowDensityFat > 3.4) {
                    ret[0] = '您本月的甘油三酯和低密度脂蛋白胆固醇均未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                }
                if (lowDensityFat >= 2.6 && lowDensityFat < 3.4) {
                    if (['low', 'between', 'common'].indexOf(this.status) > -1 && this.type === 2) {
                        ret[0] = '您本月的低密度脂蛋白胆固醇控制在目标值范围内，但甘油三酯未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                    if (['top', 'high'].indexOf(this.status) > -1 || this.type === 1) {
                        ret[0] = '您本月的甘油三酯和低密度脂蛋白胆固醇均未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                }
                if (lowDensityFat >= 1.8 && lowDensityFat < 2.6) {
                    if (['high'].indexOf(this.status) > -1 || this.type === 1) {
                        ret[0] = '您本月的甘油三酯和低密度脂蛋白胆固醇均未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                    if (['top', 'low', 'between', 'common'].indexOf(this.status) > -1 && this.type === 2) {
                        ret[0] = '您本月的低密度脂蛋白胆固醇控制在目标值范围内，但甘油三酯未控制在目标值范围内。建议您前往医院咨询是否需要调整用药方案。请您继续规律服药，合理膳食、注意控制体重、适量运动、远离烟草、保持健康生活方式，记得要定期测量哦。'
                    }
                }
            }
            return ret
        }
    }
}
</script>
<style lang="less" scoped>
</style>